var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-layout',{attrs:{"file-name":_vm.fileName,"show-header":_vm.isPublic,"can-download":_vm.isPublic,"allow-share":false}},[_c('div',{attrs:{"id":"editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }